/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Hero_Coach_Open_OtherInputs */

const en_hero_coach_open_other = /** @type {(inputs: Hero_Coach_Open_OtherInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} open this week`)
};

const pl_hero_coach_open_other = /** @type {(inputs: Hero_Coach_Open_OtherInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} wolnych w tym tygodniu`)
};

/**
* | output |
* | --- |
* | "{count} open this week" |
*
* @param {Hero_Coach_Open_OtherInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const hero_coach_open_other = /** @type {((inputs: Hero_Coach_Open_OtherInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Hero_Coach_Open_OtherInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_hero_coach_open_other(inputs)
	return en_hero_coach_open_other(inputs)
});